<template>
    <div class="tsWidgets">
        <div class="tsWidget">
            <topic-comments :topicId="topicId" :args="args" @nodeClicked="nodeClicked($event)"></topic-comments>
        </div>
        <div class="tsWidget">
            <network-graph :topicId="topicId" :args="args" height="310" width="800" @nodeClicked="nodeClicked($event)"></network-graph>
        </div>
    </div>
</template>

<script>
    import networkGraph from "./widgets/statistics/networkGraph.vue"
    import topicComments from "./widgets/topicComments.vue"
    import '../assets/vue-loading.css';
    export default {
        name: "TopicNetwork",
        components: {
            networkGraph,
            topicComments
        },
        data() {
            return {
                topicId: 0,
                loading: false
            }
        },
        mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            this.topicId = urlParams.get("topicId");
            this.args = urlParams.get("args");
        },
        methods: {
            nodeClicked(args) {
                this.loading = true
                window.LoadPanel.Show()
                var topicId = args.topicId
                var url = window.location.href.replace(window.location.search, "") + "?args=" + this.args + "&topicId=" + topicId
                setTimeout(() => {
                    window.location = url;
                })
            },
        }
    };
</script>



<style>
    .echHeader.frm-field-label {
        width: 800px;
        max-width: unset;
    }


</style>